import { Col, Form, Row } from "react-bootstrap";
import RequiredField from "../form/RequiredField";
import CloseSvg from "../../assets/close";
import styled from "styled-components";

const ErrorText = styled.span`
  color: #fb4e4e;
  font-size: 14px;
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  color: #FB4E4E;
`;

const TrackingFieldRemovable = ({
  label,
  classes,
  fieldRef,
  handleBlur,
  labelClassname,
  formGroupClasses,
  isRequired,
  noLabel,
  onRemove = () => {},
  fieldsLength,
  error,
  value,
  touched,
  ...props
}) => {
  const FormLabel = <Form.Label className={labelClassname}>{label}</Form.Label>;
  const RequiredLabel = <RequiredField>{FormLabel}</RequiredField>;

  const responsivenessControll = {
    input: {
      md: fieldsLength > 1 ? 11 : 12,
      xs: fieldsLength > 1 ? 11 : 12,
    },
    removeButton: {
      md: 1,
      xs: 1,
    },
  };

  return (
    <Form.Group id={`form-group-${props.name || props.id}`} className={formGroupClasses}>
      {isRequired && !noLabel ? RequiredLabel : !noLabel && FormLabel}
      <Row>
        <Col {...responsivenessControll.input}>
          <Form.Control
            isInvalid={error}
            className={classes}
            ref={fieldRef || null}
            value={value}
            {...props}
          />
        </Col>
        {fieldsLength > 1 && (
          <Col
            {...responsivenessControll.removeButton}
            className="pl-0 d-flex align-items-center justify-content-center"
            onClick={onRemove}
            style={{
              cursor: "pointer",
            }}
          >
            <CloseSvg />
          </Col>
        )}
      </Row>
      <ErrorText className="mt-2">{error && error}</ErrorText>
    </Form.Group>
  );
};

export default TrackingFieldRemovable;
